import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import QueryString from 'query-string';
const subsidiaryCompanyCompletionsService = {
  all(companyId, businessUnits, years, subsidiary_company_ids) {
    const query = QueryString.stringify({
      business_units: businessUnits,
      subsidiary_company_ids: subsidiary_company_ids,
      years: years
    }, {
      arrayFormat: 'comma'
    });
    return fetch("/api/companies/".concat(companyId, "/subsidiary_company_completions?").concat(query), request.get);
  }
};
export default subsidiaryCompanyCompletionsService;